import { queryOptions } from '@tanstack/react-query';

import { apiClient, apiSiblingUrl } from './client';

/*
 * What the backend says about itself (`GET /api/version`).
 *
 * That endpoint sits beside everything else we call: the client
 * addresses the HSAdmin HS namespace (`…/api/hs`), while the version belongs
 * to the whole server — hence the sibling URL (see `apiSiblingUrl`).
 *
 * It is reachable without a login (the endpoint is public), so the
 * footer can name both builds on the login page as well.
 */
export const backendVersionUrl = (base) => apiSiblingUrl('/version', base);

export const versionKeys = {
  backend: ['version', 'backend'],
};

export const versionQueries = {
  backend: () =>
    queryOptions({
      queryKey: versionKeys.backend,
      queryFn: async () => {
        const { data } = await apiClient.get(backendVersionUrl());
        return data;
      },
      /* no configured API means no backend to ask — under jest, where
         the variable is unset, this keeps the footer from firing a
         request at whatever host the test runner happens to be */
      enabled: Boolean(process.env.REACT_APP_API_BASE_URL),
      /* the running server does not change under the reader's hands,
         so asking once per session is enough */
      staleTime: Infinity,
      /* an unreachable backend leaves the footer naming the frontend
         alone; it must never turn into a retry storm behind a page
         that otherwise works */
      retry: false,
    }),
};
